import {
    isoAndUnixZodSchema,
    nowIsoAndUnix,
} from "@@/shared/date-time/iso-and-unix";
import { userIdZodSchema } from "@@/shared/users/user-id";
import type { Branded } from "@@/utilities/branded";
import { genericId } from "@@/utilities/generic-id";
import { z } from "zod";

type ReservationCommentId = Branded<string, "ReservationCommentId">;
const ReservationCommentIdPrefix = "reservation_comment__";
const {
    zodSchema: reservationCommentIdZodSchema,
    factory: ReservationCommentIdFactory,
    assert: isReservationCommentId,
} = genericId<ReservationCommentId>(ReservationCommentIdPrefix);

const reservationCommentZodSchema = z.object({
    _type: z.literal("RESERVATION_COMMENT"),
    _id: reservationCommentIdZodSchema,
    _createdAt: isoAndUnixZodSchema,
    _userId: userIdZodSchema,

    comment: z.string(),
    replaced: z.boolean().optional(),
    _replacedBy: userIdZodSchema.optional(),
    replacedByCommentId: reservationCommentIdZodSchema.optional(),
});

type ReservationComment = z.infer<typeof reservationCommentZodSchema>;

const reservationCommentFactory = (
    params: Omit<ReservationComment, "_id" | "_createdAt" | "_type">,
): ReservationComment => {
    return {
        ...params,
        _id: ReservationCommentIdFactory(),
        _createdAt: nowIsoAndUnix(),
        _type: "RESERVATION_COMMENT",
    };
};

export {
    isReservationCommentId,
    reservationCommentFactory,
    ReservationCommentIdFactory,
    ReservationCommentIdPrefix,
    reservationCommentIdZodSchema,
    reservationCommentZodSchema,
};
export type { ReservationComment, ReservationCommentId };
